import React from 'react';

export const KaenguruText = {
  AboutKaenguru: 'About Mathe mit dem Känguru',
  AboutKaenguruText:
    'This app helps kids to practice math and to prepare for the Känguru math competition in a playful way.',

  TheChallenge: 'The Challenge',

  TheChallengeText: (
    <>
      Create an appealing redesign and redevelop the old app from scratch in the
      shortest time possible.
    </>
  ),

  MyRole: 'My Role',

  MyRoleText: (
    <>
      For this project I was UX / Product Designer,
      <br />
      UI Designer, React Native Developer.
      <br />
      <br />
      My main tasks included: Stakeholder interviews, research, design execution
      and validation, app development for iOS and Android.
    </>
  ),

  DesignProcess: 'Design Process',

  DesignProcessSub: 'THE DOUBLE DIAMOND DESIGN MODEL',

  DesignProcessText: (
    <>
      The official Double Diamond design model has four stages:
      <br />
      Discovery, Definition, Development and Delivery. Together, these stages
      work as a map designers can use to organize their thoughts in order to
      improve the creative process.
    </>
  ),

  Survey: 'Survey',

  SurveyText: (
    <>
      To better understand the potential userbase of Taskly, I used Survey
      Monkey for survey creation and data analysis. This effort helps identify
      engagement opportunities / features.
      <br />
      <br />
      Conclusion <br />
      Some must-have main features of a family organizer app differ from those
      of a task management app >> the wish for a good shared family calendar and
      a meal planner. Taskly can be much more complex than a common shared
      calendar or a simple to do app. The willingness to learn the features of
      an app seems to be present.
    </>
  ),

  Interviews: 'Interviews',

  InterviewText: (
    <>
      Goal of the interviews
      <br />
      The interviews should help me to get still closer to more possible
      must-have features of Taskly. Or maybe make me reconsider some of my
      current must-have features for Taskly’s MVP afterwards.
      <br />
      <br />
      Conclusion <br />
      The interviews helped to define the features for Taskly's MVP version more
      precisely: Calendar, Recurring Events, Reminders, Shopping list,
      Lists/Tasks, Share, Communicate/Messaging, Meal Planner.
    </>
  ),

  UserPersonas: 'User Personas',

  UserPersonasText:
    'Utilizing the research I’ve conducted thus far I created three user personas. A user persona is a representation of the ideal user and his or her personalities. These user personas represent Taskly’s key audience. They were used as a reference when creating the layout and structure of Taskly. Nearly every single decision I made regarding the features, components, design elements, and functionality of taskly was based on these user personas.',

  TaskModel: 'Task Model',

  TaskModelText:
    'Task modeling gives you as a UX designer insight into understanding what people want and how you can go about designing it. It’s the process of unearthing the steps people take and the decisions they need to make while using a service—two pieces of knowledge that will greatly benefit the structure of a design in development.',

  CustomerExperienceMap: 'Customer Experience Map',

  CustomerExperienceMapText:
    'A customer experience map is a tool for visualizing all of the journeys a customer may experience when using a particular product, as well as how all of these journeys are connected. Customer experience maps are more effective in the early stages of development—when you’re still trying to understand your customers and how they interact with your product.',

  OpenCardSort: 'Open Card Sort',

  OpenCardSortText: (
    <>
      Conclusion
      <br />
      All participants came to quite similar results and there were no totally
      unexpected surprises. Apparently, the features are relatively clear and
      not too complex, so grouping was not difficult.
      <br />
      Also, my pre-selection of cards seemed to be good: there were no
      misunderstandings and I hadn’t forgotten anything important.
    </>
  ),

  SiteMap: 'Site Map',

  SiteMapText:
    'With all the insights I had gathered so far, I was now able to create a sitemap.',

  PaperPrototypes: 'Paper Prototypes & Testing with Marvel App',

  PaperPrototypesText: (
    <>
      Conclusion
      <br />
      Actually, everything went according to plan. There were no big problems,
      the Marvel App runs well and I think for the participants it is also
      easier to test the paper prototypes in this way. Only using paper requires
      a lot more imagination.
      <br />
      Paper prototyping is really fun and makes a lot of sense: It costs nearly
      nothing, is fast and allows rapid iteration.
    </>
  ),

  Wireframes: 'Wireframes',

  WireframesText:
    'Next I created wireframes and turned them into interactive prototypes using invision. That’s a great way to test user flows and find hidden pain points.',

  UserFlow: 'User Flow',

  UserFlowText:
    'To ensure that every route is smooth and free of bumps, shedding light on pain points and stumbling blocks or missing steps, I created user flows. They provide the big picture, letting me visualize exactly how and what users will see as they work through all the various parts of Taskly. ',

  StyleTile: 'Style Tile, UI Kit & Style Guide',

  StyleTileText:
    'Now it was time to define fonts and colors and to design UI elements. The result flowed first into a style tile, then into a UI Kit and finally into a comprehensive style guide.',

  VisualDesign: 'Visual Design',

  VisualDesignText: 'VisualDesignText missing',
};
